import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import { deleteCategory } from '../../../../../../../../crud/menu_api/categories';
import { ParentsCategorys, RawParentsCategorys } from '../../../../types';

interface DeleteCategoryProps {
  showDeleteModal: boolean;
  setShowDeleteModal: (show: boolean) => void;
  currentData: RawParentsCategorys[];
  setCurrentData: (data: RawParentsCategorys[]) => void;
  currentCategory: ParentsCategorys;
  originalCategories: ParentsCategorys[]; // O el mismo tipo que uses en Table
  setOriginalCategories: (data: ParentsCategorys[]) => void;
  setCategories: (data: ParentsCategorys[]) => void;
}

const DeleteCategory: React.FC<DeleteCategoryProps> = ({
  showDeleteModal,
  setShowDeleteModal,
  currentData,
  setCurrentData,
  currentCategory,
  originalCategories, 
  setOriginalCategories,
  setCategories,
}) => {

  const [isLoading, setIsLoading] = useState(false);

  const handleDeleteCategory = () => {
    setIsLoading(true);
    deleteCategory(Number(currentCategory.category_id))
      .then(response => {
        toast.success('Categoría eliminada con éxito!');
        const updatedOriginalCategory = originalCategories.filter(cat => cat.category_id !== currentCategory.category_id);
        setCategories(updatedOriginalCategory);
        setOriginalCategories(updatedOriginalCategory);
        setCurrentData(updatedOriginalCategory);
        setShowDeleteModal(false);
      })
      .catch(error => {
        console.error('Error al eliminar la categoría:', error);
        toast.error('Error al eliminar la categoría');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">Confirmar Eliminación</Modal.Title>
        </div>
        <Button
          variant="none"
          className="modal-close-button"
          onClick={() => setShowDeleteModal(false)}
        >
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        ¿Estás seguro que quieres eliminar esta categoría?
      </Modal.Body>
      <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button
            variant="secondary"
            className="form-button-cancel"
            onClick={() => setShowDeleteModal(false)}
            disabled={isLoading}
          >
            Cancelar
          </Button>
          <Button 
            variant="danger"
            className="form-button-create"
            onClick={handleDeleteCategory}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Eliminando...
              </>
            ) : (
              'Eliminar'
            )}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteCategory;
